// Apresentação do caixa compartilhada pela listagem de caixas e pelo detalhe, para as duas
// mostrarem o mesmo responsável e a mesma marca de caixa automático.

/** Caixa automático: recebe as liquidações do gateway e as baixas financeiras, sem gaveta. */
export const isIntegrationCash = (cash) => Boolean(cash?.automatic);

/**
 * Nome exibido como responsável pelo caixa.
 *
 * O caixa automático do gateway não tem usuário de abertura, porque ninguém o abriu. Em vez de
 * deixar a coluna vazia, mostra a origem do lançamento. Há mais de um caixa automático por filial
 * (o do gateway e o financeiro, que recebe as baixas de contas a pagar/receber): a observação é o
 * que distingue os dois, então ela vale mais como identificação do que um rótulo fixo igual.
 *
 * @param {object} cash caixa da listagem
 * @param {function} t tradução do i18n
 */
export const resolveCashOwner = (cash, t) => cash?.openingUser?.fullName?.trim()
    || (isIntegrationCash(cash) ? (cash?.obs?.trim() || t('cash_flow.automatic_cash_user')) : '-');

/**
 * Situação da gaveta a partir da diferença entre o dinheiro contado e o esperado.
 *
 * Usada pela confirmação do fechamento (enquanto o operador digita a contagem) e pelo detalhe do
 * caixa (com a diferença calculada pelo backend), para as duas telas falarem igual.
 *
 * @param {number|null|undefined} difference contado menos esperado; positiva quando sobrou
 * @returns {{key: string, tone: string, amount: number}|null} nulo sem contagem; key é a chave de
 *          tradução (cash_flow.drawer_matches, drawer_short ou drawer_over) e amount o valor absoluto
 */
export const describeDrawerDifference = (difference) => {
    if (difference === null || difference === undefined || Number.isNaN(Number(difference))) {
        return null;
    }
    const value = Number(difference);
    // Abaixo de meio centavo é arredondamento, e "faltam R$ 0,00" só confunde.
    if (Math.abs(value) < 0.005) {
        return { key: 'cash_flow.drawer_matches', tone: 'match', amount: 0 };
    }
    return value < 0
        ? { key: 'cash_flow.drawer_short', tone: 'short', amount: Math.abs(value) }
        : { key: 'cash_flow.drawer_over', tone: 'over', amount: value };
};
